export enum NotificationType {
  PLANNED_MAINTENANCE = 'planned_maintenance',
  MAINTENANCE = 'maintenance',
}

export enum NotificationLocation {
  SIGNED_IN = 'signed_in',
  SIGNED_OUT = 'signed_out',
}